import { createElementBlock as o, openBlock as e, createElementVNode as r } from "vue";
import n from "./index289.js";
const s = {}, l = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function c(p, t, a, i, m, f) {
  return e(), o("svg", l, t[0] || (t[0] = [
    r("path", {
      fill: "currentColor",
      d: "M17.657 11.25a.75.75 0 0 1 .101 1.493l-.101.007H6.343a.75.75 0 0 1-.102-1.493l.102-.007h11.314Z"
    }, null, -1)
  ]));
}
const u = /* @__PURE__ */ n(s, [["render", c]]);
export {
  u as default
};
